import type { Requirements } from 'app/routes';

import { type Amounts, setAmounts } from 'store/autoReducers';
import {
    type BalanceHistory,
    type BalanceStatistic,
    type BonusHistory,
    setBalanceHistory,
    setBalanceStatistic,
    setBonusHistory,
} from 'store/models/balance';

export const BalanceAndBonusesRequirements: Requirements<{
    depositAmount: Amounts;
    balanceStatistic: BalanceStatistic;
    balanceHistory: { transactions: BalanceHistory };
    bonusHistory: { bonuses: BonusHistory };
}> = {
    methods: () => ({
        depositAmount: { url: '/api/v1/catalog/depositAmount' },
        balanceStatistic: { url: '/api/v1/account/balance/statistic/short' },
        bonusHistory: { url: '/api/v1/account/balance/bonus' },
        balanceHistory: { url: '/api/v1/account/balance/history/year' },
    }),
    resolve: ({ result: { depositAmount, balanceStatistic, bonusHistory, balanceHistory } }) => [
        setAmounts(depositAmount),
        setBalanceStatistic(balanceStatistic),
        setBonusHistory(bonusHistory.bonuses),
        setBalanceHistory(balanceHistory.transactions),
    ],
};
